import {useEffect,useState} from 'react';
const key='innov_theme';
export function useGlobalTheme(){
 const [theme,setTheme]=useState(()=>localStorage.getItem('innov_theme_palette')==='slate-v1'&&localStorage.getItem(key)==='dark'?'dark':'light');
 useEffect(()=>{
  document.documentElement.dataset.theme=theme;
  document.documentElement.style.colorScheme=theme;
  localStorage.setItem(key,theme);
  localStorage.setItem('innov_theme_palette','slate-v1');
  document.cookie=`${key}=${theme}; Path=/; Max-Age=31536000; SameSite=Lax${window.location.hostname==='innov.ams-crm.fr'?'; Domain=innov.ams-crm.fr; Secure':''}`;
  document.cookie=`innov_theme_palette=slate-v1; Path=/; Max-Age=31536000; SameSite=Lax${window.location.hostname==='innov.ams-crm.fr'?'; Domain=innov.ams-crm.fr; Secure':''}`;
 },[theme]);
 useEffect(()=>{const sync=e=>{if(e.key===key&&['light','dark'].includes(e.newValue))setTheme(e.newValue);};window.addEventListener('storage',sync);return()=>window.removeEventListener('storage',sync);},[]);
 return [theme,()=>setTheme(current=>current==='dark'?'light':'dark')];
}
